import { Pipe, PipeTransform } from '@angular/core';
import { CustomerOverview } from '../models/customer.model';

@Pipe({
    name: 'filterCustomerTable'
})
export class FilterCustomerTablePipe implements PipeTransform {

    transform(customers: CustomerOverview[], filterText: string) {
        if (customers == null)
            return null;
        return customers.filter(c => {
            if (c.CustomerName != null && c.CustomerName.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
                return true;
            else if (c.DealershipName != null && c.DealershipName.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
                return true;
            else if (c.Email != null && c.Email.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
                return true;
            return false;
        });
    }

}
